import { render, staticRenderFns } from "./LiveChatAutoTreeNode.vue?vue&type=template&id=445e41d8&scoped=true&"
import script from "./LiveChatAutoTreeNode.vue?vue&type=script&lang=js&"
export * from "./LiveChatAutoTreeNode.vue?vue&type=script&lang=js&"
import style0 from "./LiveChatAutoTreeNode.vue?vue&type=style&index=0&id=445e41d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "445e41d8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VIcon,VSelect})
